var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32007 6.82001L8.29339 7.79333",
    stroke: "#424A63",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 1.98213L19 3.35862",
    stroke: "#424A63",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5178 18.5L34.1413 18.5",
    stroke: "#424A63",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85889 18.5L2.4824 18.5",
    stroke: "#424A63",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6799 6.82001L29.7066 7.79333",
    stroke: "#424A63",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8462 19.1073C27.8571 17.5282 27.4451 15.975 26.653 14.6089C25.861 13.2428 24.7177 12.1137 23.3419 11.3386C21.9661 10.5636 20.4079 10.1709 18.8291 10.2014C17.2503 10.2319 15.7084 10.6845 14.3636 11.5121C13.0187 12.3397 11.9199 13.5122 11.1812 14.9078C10.4425 16.3035 10.0909 17.8714 10.1627 19.4489C10.2346 21.0263 10.7274 22.5558 11.59 23.8785C13.1303 26.2405 14.0423 27.1087 14.0423 29.9195C14.0423 30.1802 14.1458 30.4302 14.3302 30.6146C14.5145 30.7989 14.7645 30.9025 15.0252 30.9025H22.9743C23.235 30.9025 23.485 30.7989 23.6694 30.6146C23.8537 30.4302 23.9572 30.1802 23.9572 29.9195C23.9572 27.041 24.9774 26.1864 26.5075 23.7382C27.3757 22.3491 27.8393 20.7454 27.8462 19.1073Z",
    fill: "#1D202B",
    stroke: "#424A63",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.468 30.9026H22.5319V33.4681C22.5319 35.4187 20.9506 37 19 37C17.0493 37 15.468 35.4187 15.468 33.4681V30.9026Z",
    fill: "#424A63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderBulb);
export default __webpack_public_path__ + "static/media/loader-bulb.95ae1c7ef889a4f990515ca704427a20.svg";
export { ForwardRef as ReactComponent };